import { Box } from '@mantine/core';
import { useGetColor } from '../hooks';
import type { IconPropsType } from './types';

export const LinkIcon = ({ color, size = 18, sx, ...props }: IconPropsType) => {
  const iconColor = useGetColor(color);
  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke={iconColor}
        d="M8.57143 10.8571L4.94677 14.4818C4.34056 15.088 4 15.9102 4 16.7675C4 18.5528 5.44723 20 7.23249 20C8.0898 20 8.91199 19.6594 9.5182 19.0532L13.1429 15.4286M15.4286 13.1429L19.0532 9.5182C19.6594 8.91199 20 8.0898 20 7.23249C20 5.44723 18.5528 4 16.7675 4C15.9102 4 15.088 4.34056 14.4818 4.94677L10.8571 8.57143M8.57143 15.4286L15.4286 8.57143"
        strokeWidth="1.5"
      />
    </Box>
  );
};
